import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-direct_mini",
  "use": "icon-direct_mini-usage",
  "viewBox": "0 0 12 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 12 10\" id=\"icon-direct_mini\"><path fill=\"#212121\" d=\"m11.543 8.911-.321-2.668a.107.107 0 0 0-.182-.063l-.794.796-3.634-3.632a.215.215 0 0 0-.303 0L4.946 4.706 1.24 1a.11.11 0 0 0-.151 0l-.603.605a.11.11 0 0 0 0 .152l4.309 4.31c.083.085.22.085.302 0l1.364-1.361 3.028 3.026-.794.795a.107.107 0 0 0 .063.182l2.668.321c.068.01.127-.05.117-.119\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol